
import { IApiMachineGroup, IApiMachineDepartment } from '@tap/data-providers';

export enum DataCollectionCode {
    MesShiftTaskStatReportResult = 'mes_shift_task_stat_report_result',
    MesPlanVsFactReportResult = 'mes_plan_vs_fact_report_result',
    MesTechnologyVariationReportResult = 'mes_technology_variation_report_result',
    DocUpdateIssueStatReport = 'doc_issue_stat_report_result',
    DocUpdateIssueSlaReport = 'doc_issue_sla_report_result',
}

export type DataCollection<T> = {
    data: T,
    code: DataCollectionCode,
    changedAtUtc: string,
}

export type MesPlanVsFactReportRow = {
    group: IApiMachineGroup,
    department: IApiMachineDepartment,
    plannedTimeMin: number,
    factTimeMin: number,
}

export type MesShiftTaskStatReportRow = {
    group: IApiMachineGroup,
    department: IApiMachineDepartment,
    plannedForTodayCount: number,
    inWorkCount: number,
    completedTodayCount: number,
    plannedForTomorrowCount: number,
}

export type MesTechnologyVariationReportRow = {
    component: {
        productUnitId: number,
        name: string,
        vendorCode: string,
    },
    department: IApiMachineDepartment,
    operation: {
        id: number,
        name: string,
        code: string,
        machineProcessTime: number,
        unitProcessTime: number,
    },
    //кол-во заказов
    assignmentCount: number,
    //среднее плановое время
    avgUnitPlanTime: number,
    //среднее фактическое время
    avgUnitWorkTime: number,
    //максимальное плановое время
    maxUnitPlanTime: number,
    //максимальное фактическое время
    maxUnitWorkTime: number,
    //минимальное плановое время
    minUnitPlanTime: number,
    //минимальное фактическое время
    minUnitWorkTime: number,
    routeCode: string,
    routePointStage: string,
    //суммарное завершенное количество
    sumAmountCompleted: number,
    //суммарное плановое количество
    sumAmountPlanned: number,
    //суммарное плановое время
    sumPlanTime: number,
    //суммарное фактическое время
    sumWorkTime: number,
    //время по техпроцессу
    unitBaseTime: number,
}

export type GetCollectionParams = {
    [key: string]: DataCollectionCode,
}

export type GetCollectionObjResult = {
    [key: string]: DataCollection<any>,
}

export type DocUpdateIssueStatReportRow = {
    completedTodayCount: number,
    inWorkIssueCount: number,
    newIssueCount: number,
    issueType: string,
    documentCode: string,
    department?: IApiMachineDepartment,
}

export type DocUpdateIssueSlaReportRow = {
    avgLatencyPeriod: number,
    avgResponseTime: number,
    avgTotalTime: number,
    maxLatencyPeriod: number,
    maxResponseTime: number,
    maxTotalTime: number,
    totalCount: number,
    completedOnTimeCount: number,
    issueType: string,
    documentCode: string,
    department: IApiMachineDepartment,
}
